import { initializeApp } from "firebase/app";
import { deleteToken, getMessaging, getToken } from "firebase/messaging";

//Firebase Config values imported from .env file
const firebaseConfig = {
  apiKey: "AIzaSyAl6xa19jiH-VB1sKrG9lDu104q-jMzNr0",
  authDomain: "deepcarecis-75c6f.firebaseapp.com",
  projectId: "deepcarecis-75c6f",
  storageBucket: "deepcarecis-75c6f.firebasestorage.app",
  messagingSenderId: "247521284968",
  appId: "1:247521284968:web:7fe38cacc4fe229af73cdd"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig,"cis");

// Messaging service
export const messaging = getMessaging(app);

export const requestPermissionFb = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      return;
    }

    const registration = await navigator.serviceWorker.ready; // 👈 Đợi SW sẵn sàng

    const token = await getToken(messaging, {
      vapidKey: 'BN_M53NP6WXlwtvBjDAX-HdW6lXiIFAE9JuZOxy8qrflNAnMQjqxb3ybbKymrBI8pyQSa7jDtnXa91Th_DrHRkk',
      serviceWorkerRegistration: registration, // 👈 Truyền rõ SW đã đăng ký
    });

    if (token) {
      localStorage.setItem('fcmToken', token);
    }

    console.log("🔥 Token FCM: ", token);
    return token;
  } catch (error) {
    console.error("❌ requestPermissionFb failed: ", error);
  }
};

export const unregisterFcmToken = async () => {
  try {
    // Sử dụng biến messaging đã được export ở trên
    const currentToken = await getToken(messaging, {
      vapidKey: 'BN_M53NP6WXlwtvBjDAX-HdW6lXiIFAE9JuZOxy8qrflNAnMQjqxb3ybbKymrBI8pyQSa7jDtnXa91Th_DrHRkk',
    });
    
    if (currentToken) {
      // Sử dụng hàm deleteToken từ firebase/messaging
      await deleteToken(messaging);
      localStorage.removeItem('fcmToken');
      console.log('Đã hủy đăng ký FCM token thành công');
    } else {
      console.log('Không có token FCM để hủy đăng ký');
    }
    
    return true;
  } catch (error) {
    console.error('Lỗi khi hủy đăng ký FCM token:', error);
    throw error;
  }
};


// onMessage(messaging, (payload) => {});
